import { Label } from "@/components/ui/label";

interface SettingsFieldProps {
  label: string;
  description?: string;
  error?: string | null;
  required?: boolean;
  htmlFor?: string;
  children: React.ReactNode;
}

export function SettingsField({
  label,
  description,
  error,
  required,
  htmlFor,
  children,
}: SettingsFieldProps) {
  return (
    <div className="space-y-2">
      <Label
        htmlFor={htmlFor}
        className="typo-label text-[color:var(--color-text-md)]"
      >
        {label}
        {required && <span className="text-destructive ml-0.5">*</span>}
      </Label>
      {description && (
        <p className="typo-body text-xs text-[color:var(--color-text-lo)]">
          {description}
        </p>
      )}
      {children}
      {error && <p className="typo-body text-xs text-destructive">{error}</p>}
    </div>
  );
}
